export default "__VITE_ASSET__uGqiO$HV__"